import React, { useEffect } from "react";
import "./App.css";
import Sidebar from "./Components/Sidebar/Sidebar";
import PageContent from "./Components/PageContent/PageContent";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "./Pages/Login/Login";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { createSession } from "./Redux/reducers/SessionSlice";
import { jwtDecode } from "jwt-decode";
import { Routes, Route } from "react-router-dom"; // ✅ added this
import CandRegOpenLink from "./Pages/AplicantTrackingSystem/CandRegOpenLink";
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';

const App = () => {
  const dispatch = useDispatch();
  const token = Cookies.get("jwt");

  useEffect(() => {
    try {
      const decoded = jwtDecode(token);
      dispatch(createSession(decoded));
    } catch (error) {
      console.error("Error decoding token:", error.message);
    }
  }, [token]);

  return (
    <>
      <div className="App">
        <Routes>
          {/* ✅ Publicly accessible route */}
          <Route path="/candregopenlink" element={<CandRegOpenLink />} />

          {/* ✅ Authenticated routes */}
          {token ? (
            <Route
              path="/*"
              element={
                <div className="SideMenuAndPageContent">
                  <Sidebar />
                  <PageContent />
                </div>
              }
            />
          ) : (
            // ✅ Default to login if not authenticated
            <Route path="/*" element={<Login />} />
          )}
        </Routes>
      </div>

      <ToastContainer />
    </>
  );
};

export default App;
